// OrbitMenu Configuration
// Centralized configuration for the radial/orbit menu system

export const orbitMenuConfig = {
  // Visual Settings
  visual: {
    radius: 100,                    // Base radius in pixels
    menuOffset: 150,                // Offset when menu opens to prevent cutoff

    // Brand Colors
    colors: {
      primary: "#D7AC74",           // Zen brand gold
      primaryDark: "#AC8E66",       // Zen brand dark gold
      background: "#1f2937",        // Gray-800
      backgroundDark: "#111827",    // Gray-900
      text: "#F3E6D3",              // Soft gold tint
      border: "#4b5563",            // Gray-600
      borderHighlight: "#D7AC74",   // Zen brand gold
      buttonBg: "#0f172a",          // Slate-900
      buttonOutline: "#D7AC74",     // Zen brand gold
      buttonOutlineWidth: 2,
      menuItemBg: "#111827",        // Gray-900
      menuItemOutline: "#D7AC74",   // Zen brand gold
      menuItemOutlineWidth: 2,
      backdrop: "rgba(0, 0, 0, 0)",  // Transparent - only blur effect
    },

    // Button Styles
    button: {
      width: 64,                    // w-16 -> larger for better text spacing
      height: 64,                   // h-16 -> larger for better text spacing
      fontSize: "12px",
      fontFamily: "mono",
    },

    // Backdrop
    backdrop: {
      blur: "8px",
      opacity: 0.4,
    },

    // Logo Configuration
    logo: {
      type: "image",                // "image" | "text" - Default: always show image
      image: null,                  // Will use logoBackPath from config.js
      text: "B",                    // Fallback text if type is "text"
    }
  },

  // Animation Settings
  animation: {
    // Logo rotation
    logo: {
      openRotation: 180,
      closeRotation: 0,
      stiffness: 100,
      damping: 50,
    },

    // Menu item animations
    menuItem: {
      stiffness: 260,
      damping: 20,
      staggerDelay: 0.05,           // Delay between items in seconds
    },

    // Scroll animation
    scroll: {
      stiffness: 150,
      damping: 11,
    },

    // Backdrop fade
    backdrop: {
      duration: 0.2,
    }
  },

  // Behavior Settings
  behavior: {
    scrollBehavior: "smooth",       // "smooth" | "fixed" | "disabled"
    closeOnBackdropClick: true,
    closeOnItemClick: true,
    resetSubmenuOnClose: true,
  },

  // Tooltip Settings
  tooltip: {
    enabled: true,
    duration: 6000,                 // 6 seconds
    repeatDelay: 10000,             // 10 seconds
    maxShows: 2,
    text: "Menü öffnen",
  },

  // Accessibility
  accessibility: {
    ariaLabel: "Hauptmenü",
    keyboardNavigation: true,
    focusTrapping: true,
  },

  // Multi-Layer Support (for future enhancement)
  layers: [
    {
      id: "main",
      radius: 100,
      startAngle: 0,
      endAngle: -180,
    }
    // Add more layers here for multi-ring menus
  ],
};

// Main Menu Items Configuration
export const mainMenuItems = [
  {
    id: "menu-overlay",
    label: "Menü",
    angle: 0,
    action: "openOverlay",
    isMainMenu: true,
    icon: null,                     // Future: icon support
    tooltip: "Vollständiges Menü öffnen",
  },
  {
    id: "lernstudio",
    label: "Lern Studio",
    angle: -45,
    route: "/lernstudio",
    icon: null,
    tooltip: "Zum Lern Studio",
  },
  {
    id: "contact",
    label: "Sag Hallo",
    angle: -90,
    route: "/contact",
    icon: null,
    tooltip: "Kontakt aufnehmen",
  },
  {
    id: "about",
    label: "Einfach Ich",
    angle: -135,
    action: "openSubmenu",
    submenu: "about",
    hasSubmenu: true,
    icon: null,
    tooltip: "Über mich erfahren",
  },
  {
    id: "home",
    label: "Moin {name}",           // {name} will be replaced dynamically
    angle: -180,
    route: "/",
    icon: null,
    tooltip: "Zur Startseite",
    dynamic: true,                  // Label is dynamic
  }
];

// About Submenu Items Configuration
export const aboutSubmenuItems = [
  {
    id: "back",
    label: "Zurück",
    angle: 0,
    action: "closeSubmenu",
    isBack: true,
    icon: null,
    tooltip: "Zurück zum Hauptmenü",
  },
  {
    id: "about-overview",
    label: "Ich",
    angle: -60,
    route: "/about#overview",
    icon: null,
    tooltip: "Über mich",
  },
  {
    id: "references",
    label: "Referenz",
    angle: -120,
    route: "/about#referenzen",
    icon: null,
    tooltip: "Referenzen ansehen",
  },
  {
    id: "kompass",
    label: "Kompass",
    angle: -180,
    route: "/about#kompass",
    icon: null,
    tooltip: "Mein Kompass",
  }
];

// Preset Configurations (for Visual Customizer)
export const orbitMenuPresets = {
  compact: {
    visual: { radius: 80, menuOffset: 120 },
    animation: { menuItem: { staggerDelay: 0.03 } },
  },

  spacious: {
    visual: { radius: 150, menuOffset: 200 },
    animation: { menuItem: { staggerDelay: 0.08 } },
  },

  fast: {
    animation: {
      logo: { stiffness: 400, damping: 20 },
      menuItem: { stiffness: 350, damping: 15, staggerDelay: 0.02 },
    },
  },

  smooth: {
    animation: {
      logo: { stiffness: 200, damping: 30 },
      menuItem: { stiffness: 180, damping: 25, staggerDelay: 0.1 },
    },
  },
};

export default orbitMenuConfig;
